import React from 'react';
import logo from '../../../assets/tigaly-ai-logo.svg';
import AuthChatPreview from './AuthChatPreview';
import { AuthFormColumn, AuthFormInner, AuthLogo, AuthPage, AuthPreviewColumn } from './AuthLayout.styles';

function AuthLayout({ children, logoAside = null }) {
  return (
    <AuthPage>
      <AuthFormColumn>
        <AuthFormInner>
          <AuthLogo>
            <img src={logo} alt="Tigaly AI" />
            {logoAside && <span className="aside">{logoAside}</span>}
          </AuthLogo>
          {children}
        </AuthFormInner>
      </AuthFormColumn>
      <AuthPreviewColumn>
        <AuthChatPreview />
      </AuthPreviewColumn>
    </AuthPage>
  );
}

export default AuthLayout;
